import React from 'react';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import PaginatedTable from '../../commonComponents/util/PaginatedTable';
import CampaignDetailsIndividualsTableRow from './CampaignDetailsIndividualsTableRow';
import ConfirmationModal from '../../commonComponents/shared/ConfirmationModal';

export default class CampaignDetailsIndividualsTable extends NavigationComponent {
    constructor(props) {
        super(props);

        this.state = {
            showModals: {
                confirmationModal: false
            },
            selectedRecord: {}
        }

        this.getTableRow = this.getTableRow.bind(this);
    }

    getTableRow(recipient) {
        return <CampaignDetailsIndividualsTableRow key={recipient.recipientId}
            canUpdate={this.props.canUpdate}
            canUpdateIndividual={this.props.canUpdateIndividual}
            canUpdateAmount={this.props.canUpdateAmount}
            recipient={recipient}
            campaignId={this.props.campaign.campaignId}
            campaignName={this.props.campaign.name}
            maxAmount={recipient.payeeIsIsraeli ? this.props.campaign.maxAmountShekel : this.props.campaign.maxAmountDollar}
            isIsraeli={recipient.payeeIsIsraeli}
            funds={recipient.payeeIsIsraeli ? this.props.funds.IL : this.props.funds.US}
            campaignIndivCategories={this.props.campaignIndivCategories}
            toggleSelect={this.props.toggleSelect}
            selected={this.props.selected.map(r => r.recipientId).indexOf(recipient.recipientId) >= 0}
            update={(...updateProps) => this.props.update(this.props.campaign.campaignId, ...updateProps)}
            updating={this.props.updating[recipient.recipientId] === true}
            updateError={this.props.updating.hasOwnProperty(recipient.recipientId) && this.props.updating[recipient.recipientId] !== true}
            updateErrorMessage={(this.props.updating.hasOwnProperty(recipient.recipientId) && this.props.updating[recipient.recipientId]) !== true ? this.props.updating[recipient.recipientId] : ''}
            remove={selectedRecord => {
                this.setState({ selectedRecord });
                this.toggleModal("confirmationModal");
            }} />;
    }

    render() {
        let columns = [
            { id: 'name', title: 'Name', sortable: true },
            { id: 'amount', title: 'Amount', sortable: true },
            { id: 'fund', title: 'Fund', sortable: true },
            { id: 'category', title: 'Category', sortable: true }
        ];
        if (this.props.canUpdateIndividual) columns.concat([
            { id: 'edit', title: 'Edit', sortable: false }
        ]);
        if (this.props.canUpdate) columns.concat([
            { id: 'remove', title: 'Remove', sortable: false }
        ]);

        return <div>
            <PaginatedTable
                name="campaign recipients"
                page={this.props.page}
                totalCount={this.props.data.totalCount}
                resultsView={this.props.resultsView}
                sort={this.props.sort}
                loading={this.props.loading}
                success={this.props.success}
                renderRow={this.getTableRow}
                columns={columns}
                records={this.props.data.records || []}
                sortData={this.props.updateTable}
                changeDataView={this.props.updateTable}
                loadData={this.props.getCampaignIndividuals} />

            <ConfirmationModal
                show={this.state.showModals.confirmationModal}
                message={this.props.campaign.campaignId ? `Are you sure you want to remove ${this.state.selectedRecord.name || 'this individual'} from the ${this.props.campaign.name || ''} campaign?` : ''}
                close={() => {
                    this.toggleModal("confirmationModal");
                    this.setState({ selectedRecord: {} });
                }}
                confirm={this.props.remove.bind(this, this.props.campaign.campaignId, this.state.selectedRecord.recipientId)}
                loading={this.props.removing.loading}
                success={this.props.removing.success}
                errorMessage={this.props.removing.message} />
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignDetails/CampaignDetailsIndividualsTable.jsx